import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="sound-player"
export default class extends Controller {
  static targets = ['play', 'pause', 'audio']

  connect() {
  }

  play(event) {
    this.audioTarget.play();
    // this.toggle_icons();
  }

  pause() {
    this.audioTarget.pause();
    // this.toggle_icons();
  }

  toggle_icons() {
    // this.playTarget.classList.toggle('d-none');
    // this.pauseTarget.classList.toggle('d-none');
  }
}
